/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

import React from 'react';

/**
 * Custom informative icon representing an unsuccessful experiment.
 * @export
 */
export const ICON_EXPERIMENT_FAILED = (
  <svg fill="none" height="176" viewBox="0 0 173 176" width="173" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M0.5 86C0.5 38.5035 39.0035 0 86.5 0C133.996 0 172.5 38.5035 172.5 86V149.763C172.5 164.253 160.753 176 146.263 176H88.5C39.8989 176 0.5 136.601 0.5 88V86Z"
      fill="#F5F5F5"
    />
    <rect fill="#057E91" height="100" rx="50" width="100" x="36.5" y="32" />
    <path
      d="M81.8333 60.9997H70.1667C67.6 60.9997 65.5 63.0997 65.5 65.6663V98.333C65.5 100.9 67.6 103 70.1667 103H81.8333V105.333C81.8333 106.616 82.8833 107.666 84.1667 107.666C85.45 107.666 86.5 106.616 86.5 105.333V58.6663C86.5 57.383 85.45 56.333 84.1667 56.333C82.8833 56.333 81.8333 57.383 81.8333 58.6663V60.9997ZM81.8333 95.9997H70.1667L81.8333 81.9997V95.9997ZM102.833 60.9997H91.1667V65.6663H100.5C101.783 65.6663 102.833 66.7163 102.833 67.9997V95.9997L91.1667 81.9997V103H102.833C105.4 103 107.5 100.9 107.5 98.333V65.6663C107.5 63.0997 105.4 60.9997 102.833 60.9997Z"
      fill="white"
    />
    <rect fill="#F5F5F5" height="56" rx="28" width="56" x="104.5" y="104" />
    <path
      d="M152.835 122.62L141.915 111.7C141.472 111.257 140.865 111 140.258 111H124.765C124.158 111 123.552 111.257 123.132 111.677L112.188 122.62C111.768 123.04 111.512 123.647 111.512 124.253V139.723C111.512 140.353 111.768 140.937 112.188 141.38L123.108 152.3C123.552 152.743 124.158 153 124.765 153H140.235C140.865 153 141.448 152.743 141.892 152.323L152.812 141.403C153.255 140.96 153.488 140.377 153.488 139.747V124.253C153.512 123.647 153.255 123.04 152.835 122.62ZM148.845 138.767L139.278 148.333H125.745L116.178 138.767V125.233L125.745 115.667H139.278L148.845 125.233V138.767Z"
      fill="#D72321"
    />
    <path
      d="M132.512 143.667C133.8 143.667 134.845 142.622 134.845 141.333C134.845 140.045 133.8 139 132.512 139C131.223 139 130.178 140.045 130.178 141.333C130.178 142.622 131.223 143.667 132.512 143.667Z"
      fill="#D72321"
    />
    <path
      d="M132.512 120.333C131.228 120.333 130.178 121.383 130.178 122.667V134.333C130.178 135.617 131.228 136.667 132.512 136.667C133.795 136.667 134.845 135.617 134.845 134.333V122.667C134.845 121.383 133.795 120.333 132.512 120.333Z"
      fill="#D72321"
    />
  </svg>
);
